<template>
    <button v-if="!confirm" @click="toggleConfirm()" type="button" class="btn btn-primary btn-xs pppp-delete-btn">
        <span class="glyphicon glyphicon-trash"></span>
        <span class="sr-only">Poista</span>
    </button>
    <div v-if="confirm" class="btn-group" role="group">
        <button @click="toggleConfirm()" type="button" class="btn btn-default btn-xs">Peruuta</button>
        <button @click="confirmDelete()" type="button" class="btn btn-primary btn-xs">Vahvista poisto</button>
    </div>
</template>

<script>
export default {
    name: 'DeleteButton',
    props: {
        deleteEventPayload: null,
        deleteEventName: String
    },
    data() {
        return {
            confirm: false
        }
    },
    methods: {
        toggleConfirm() {
            this.confirm = !this.confirm;
        },
        confirmDelete() {
            this.$emitter.emit(this.deleteEventName, this.deleteEventPayload);
        }
    }
}
</script>

<style scoped>
.pppp-delete-btn,
.btn-group {
    position: relative;
    top: -1px;
}
</style>
